import styles from "../ModalCriarRota/ModalCriarRota.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../components/Grid";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";
import api from "../../../../services/Api";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Loading from "../../../../components/components-ui/Loading/Loading";
import * as Sentry from "@sentry/react";
import CustomConfirmAlert from "../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";

const API_MOTORISTAS = "/motorista/listamotorista";
const API_LISTA_EMISSOR = `/usuario/view`;
const API_VIEW_EDIT = "/painelfreguesia/vieweditoc/";
const API_EDIT_OC = "/painelfreguesia/editoc/";

const today = new Date();
today.setDate(today.getDate() + 1);
const DATA_AMANHA = today.toISOString().split("T")[0];

function EditarFreguesia({
  freguesia,
  numeroOC,
  veiculos,
  back,
  closeModal,
  recarregaFreguesia,
  status
}) {
  const [motoristas, setMotoristas] = useState([]);
  const [emissor, setEmissor] = useState([]);
  const [dataInfosFreguesia, setDataInfosFreguesia] = useState([]);
  const [loading, setLoading] = useState(true);

  const getMostoristas = async () => {
    await api
      .get(API_MOTORISTAS)
      .then((res) => setMotoristas(res.data.data))
      .catch((error) => console.log(error));
  };

  const getInfosFreguesia = async () => {
    await api
      .get(API_VIEW_EDIT + numeroOC)
      .then((res) => {
        if (res.data.error === 0) {
          setDataInfosFreguesia(res.data.data[0]);
          console.log(res.data.data[0]);
        }
      })
      .catch((error) => console.log(error));
  };

  // Carrega emissor
  async function getEmissor() {
    await api
      .get(API_LISTA_EMISSOR)
      .then((res) => setEmissor(res.data))
      .catch((error) => console.log(error));
  }

  //Carregar selects motoristas e veiculos
  useEffect(() => {
    getMostoristas();
    getEmissor();
    getInfosFreguesia().finally(() => setLoading(false));
  }, []);

  const editarFreguesia = async (values) => {
    const data = {
      data_programacao: values?.dataFreguesia,
      id_veiculo: values?.veiculo,
      id_motorista: values?.motorista,
      valor_entrada: values?.levou,
      numero_certificado_de: values?.certificadoDe,
      numero_certificado_ate: values?.certificadoAte,
    };
    console.log(data);

    await api
      .put(API_EDIT_OC + numeroOC, data)
      .then((res) => {
        console.log(res);
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          closeModal();
          recarregaFreguesia();
        } else if (res.data.error === 2) {
          console.log(res.data);
          alertError(
            res.data.data.Freguesia,
            res.data.data.DataProgramacao,
            res.data.data.IDOC
          );
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
        Sentry.captureException(error, {
          extra: {
            response: error.response?.data.message,
            status: error.response?.status,
            url: API_EDIT_OC + numeroOC,
            payload: data,
          },
        });
      });
  };

  const alertError = (freguesia, dia, idOc) => {
    CustomConfirmAlert({
      title: "Atenção!",
      subtitle: `Existe uma freguesia ${freguesia} para o dia ${dia}. OC (${idOc}) \n
      Não é possível criar essa freguesia.\n
      Não é permitido ter duas freguesias com o mesmo veiculo para o mesmo dia em andamento
      `,
      align: "start",
    });
  };

  const validationSchema = Yup.object().shape({
    dataFreguesia: Yup.date().required("Insira a data"),
    veiculo: Yup.string().nullable().required("Insira o veiculo"),
    motorista: Yup.string().nullable().required("Insira o motorista"),
    levou: Yup.number()
      .positive()
      .min(0, "Insira um numero positivo")
      .nullable(),
    certificadoDe: Yup.string().nullable(),
    certificadoAte: Yup.string().nullable(),
    usuarioCriacao: Yup.number().nullable(),
    dataCriacao: Yup.date().nullable(),
    usuarioAlteracao: Yup.number().nullable(),
    dataAlteracao: Yup.date().nullable(),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>
        Edição Freguesia {freguesia} (OC {numeroOC})
      </h2>
      {loading ? (
        <div className={styles.loading_container}>
          <Loading display="flex" />
        </div>
      ) : (
        <Formik
          initialValues={{
            dataFreguesia: dataInfosFreguesia?.DataProgramacao,
            veiculo: dataInfosFreguesia?.IDVeiculo,
            motorista: dataInfosFreguesia?.IDMotorista,
            status: dataInfosFreguesia?.IDStatus,
            levou: dataInfosFreguesia?.ValorEntrada,
            certificadoDe: dataInfosFreguesia?.NumeroCertificadoDe,
            certificadoAte: dataInfosFreguesia?.NumeroCertificadoAte,
            usuarioCriacao: dataInfosFreguesia?.Audit_IdUsuarioCriacao,
            dataCriacao: dataInfosFreguesia?.Audit_DataCriacao,
            usuarioAlteracao: dataInfosFreguesia?.Audit_IdUsuarioAlteracao,
            dataAlteracao: dataInfosFreguesia?.Audit_DataAlteracao,
          }}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={(values) => editarFreguesia(values)}
        >
          {({ errors, touched, values, isSubmitting, isValid }) => (
            <Form>
              {/* Modal Criar Rota */}
              <div>
                <Grid>
                  <Col size={3}>
                    <label>Data da Freguesia</label>
                    <Field name="dataFreguesia">
                      {({ field }) => <input type="date" {...field} />}
                    </Field>
                    {errors.dataFreguesia && touched.dataFreguesia ? (
                      <span className={styles.alertError}>
                        {errors.dataFreguesia}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Veículo</label>
                    <Field
                      component={SelectSearch}
                      name="veiculo"
                      options={veiculos.map((values) => ({
                        label: values?.placa,
                        value: values?.IDVeiculo,
                      }))}
                    />
                    {errors.veiculo && touched.veiculo ? (
                      <span className={styles.alertError}>
                        {errors.veiculo}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Motorista</label>
                    <Field
                      component={SelectSearch}
                      name="motorista"
                      options={motoristas.map((values) => ({
                        label: values?.NomeUsuario,
                        value: values?.IdUsuario,
                      }))}
                    />
                    {errors.motorista && touched.motorista ? (
                      <span className={styles.alertError}>
                        {errors.motorista}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Status</label>
                    <Field
                      component={SelectSearch}
                      name="status"
                      options={status.map((values) => ({
                        label: values?.Status,
                        value: values?.IDStatus,
                      }))}
                      disabled
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={2}>
                    <label>Levou R$</label>
                    <Field type="number" name="levou" step={1} />
                    {errors.levou && touched.levou ? (
                      <span className={styles.alertError}>{errors.levou}</span>
                    ) : null}
                  </Col>
                  <Col size={5}>
                    <label>Nº Cert. De</label>
                    <Field type="text" name="certificadoDe" />
                    {errors.certificadoDe && touched.certificadoDe ? (
                      <span className={styles.alertError}>
                        {errors.certificadoDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={5}>
                    <label>Nº Cert. Até</label>
                    <Field type="text" name="certificadoAte" />
                    {errors.certificadoAte && touched.certificadoAte ? (
                      <span className={styles.alertError}>
                        {errors.certificadoAte}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={3}>
                    <label>Usuário Criação</label>
                    <Field
                      component={SelectSearch}
                      name="usuarioCriacao"
                      options={emissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                      disabled
                    />
                    {errors.usuarioCriacao && touched.usuarioCriacao ? (
                      <span className={styles.alertError}>
                        {errors.usuarioCriacao}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Data de Criação</label>
                    <Field name="dataCriacao">
                      {({ field }) => (
                        <input
                          type="datetime-local"
                          {...field}
                          value={field.value?.slice(0, 16)}
                          disabled
                        />
                      )}
                    </Field>
                    {errors.dataCriacao && touched.dataCriacao ? (
                      <span className={styles.alertError}>
                        {errors.dataCriacao}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Usuário Alteração</label>
                    <Field
                      component={SelectSearch}
                      name="usuarioAlteracao"
                      options={emissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                      disabled
                    />
                    {errors.usuarioAlteracao && touched.usuarioAlteracao ? (
                      <span className={styles.alertError}>
                        {errors.usuarioAlteracao}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Data de Alteração</label>
                    <Field name="dataAlteracao">
                      {({ field }) => (
                        <input
                          type="datetime-local"
                          {...field}
                          value={field.value?.slice(0, 16)}
                          disabled
                        />
                      )}
                    </Field>
                    {errors.dataAlteracao && touched.dataAlteracao ? (
                      <span className={styles.alertError}>
                        {errors.dataAlteracao}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
                <div className={styles.buttons_container}>
                  <Button
                    title="Salvar"
                    type="submit"
                    disabled={isSubmitting}
                    className={styles.button_sm}
                  />
                  <Button
                    title="Cancelar"
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => closeModal()}
                    color={"secondary"}
                    className={styles.button_sm}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
}

export default EditarFreguesia;
